var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"icone-linha-info"}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.menssagemModal))]),_c('vue-recaptcha',{ref:"recaptcha",attrs:{"sitekey":_vm.recaptchaToken},on:{"verify":_vm.logarColetorComRecaptcha,"expired":_vm.onCaptchaExpired}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }